import React from 'react'
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import {createTheme, ThemeProvider} from '@mui/material/styles'
import Login from 'containers/Login'
import Intl from 'containers/Intl'
import Main from 'containers/Main'
import Table from 'containers/Table'
import List from 'containers/List'
import Planning from 'containers/Planning'
import Scheduler from 'containers/Scheduler'
import RelationTable from 'containers/RelationTable'
import Record from 'containers/Record'
import Settings from 'containers/Settings'
import Profile from 'containers/Profile'
import UpdateConfirmation from 'containers/UpdateConfirmation'
import Auth from 'containers/Auth'
import Loader from 'components/Loader'
import Message from 'containers/Message'
import route from 'utils/enums/route'

const theme = createTheme({
	palette: {
		mode: 'light',
		primary: {
			main: '#415dd4',
			contrastText: '#FFF'
		},
		secondary: {
			main: '#d45b4a',
			contrastText: '#FFF'
		},
		success: {
			main: '#4cae4c',
			contrastText: '#FFF'
		},
		text: {
			primary: '#4a4a4a'
		}
	},
	typography: {
		fontFamily: [
			'Helvetica Neue',
			'Arial',
			'sans-serif'
		].join(',')
	},
	components: {
		MuiSnackbar: {
			styleOverrides: {
				anchorOriginBottomCenter: {
					bottom: '20px'
				}
			}
		},
		MuiSnackbarContent: {
			styleOverrides: {
				root: {
					justifyContent: 'center'
				}
			}
		},
		MuiButton: {
			styleOverrides: {
				root: {
					letterSpacing: '2px',
					fontSize: '12px',
					lineHeight: 'normal',
					height: '35px',
					borderRadius: '2px',
					minWidth: '120px'
				}
			}
		},
		MuiDialogContent: {
			styleOverrides: {
				root: {
					padding: '20px 40px'
				}
			}
		},
		MuiDialogTitle: {
			styleOverrides: {
				root: {
					padding: '40px 40px 20px 40px'
				}
			}
		},
		MuiDialogActions: {
			styleOverrides: {
				root: {
					padding: '20px 40px 40px 40px',
					margin: 0
				}
			}
		},
		MuiInput: {
			styleOverrides: {
				root: {
					fontSize: '14px'
				},
				input: {
					height: 'auto'
				},
				underline: {
					'&:after':{
						borderBottom: '2px solid #415dd4'
					}
				}
			}
		},
		MuiFormControlLabel: {
			styleOverrides: {
				label: {
					fontSize: '14px'
				}
			}
		},
		MuiAvatar: {
			styleOverrides: {
				root: {
					boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
					width: '35px',
					height: '35px'
				}
			}
		}
	}
})

export default () => (
    <ThemeProvider theme={theme}>
        <Intl>
            <UpdateConfirmation />
            <Message />
            <BrowserRouter basename='/app'>
                <Loader />
                <Routes>
                    <Route path={`${route.Module}/:id`} element={<Auth component={Main} />} />
                    <Route path={`${route.Login}`} element={<Login type='login' />} />
                    <Route path={`${route.Registration}`} element={<Login type='registration' />} />
                    <Route path={`${route.List}/:list`} element={ <Auth component={List} />} />
                    <Route path={`${route.Table}/:table`} element={<Auth component={Table} />} />
                    <Route path={`${route.Planning}/:planning/:view`} element={<Auth component={Planning} />} />
                    <Route path={`${route.Scheduler}/:scheduler/:view`} element={<Auth component={Scheduler} />} />
                    <Route path={`${route.Record}/:table/:record`}  element={<Auth component={Record} />}>
                        <Route path=':view' element={<Auth component={Record} />} />
                    </Route>
                    <Route path={`${route.Relation}/:relation/:record`}  element={<Auth component={RelationTable} />} />
                    <Route path={`${route.Settings}/:section`} element={<Auth component={Settings} />} />
                    <Route path={`${route.Profile}`} element={<Auth component={Profile} />} />
                    <Route path="*" element={<Auth component={Main} />} />
                </Routes>
            </BrowserRouter>
        </Intl>
    </ThemeProvider>
)
